module.exports = __webpack_public_path__ + "img/in-love.4d0861ba.svg";